export function getMiddleFrameURL(gatewayName: string): string {
  // timestamp is added for cache-burst in middleframe service
  return `${MIDDLE_FRAME_URL}?gateway=${gatewayName}&timestamp=${TIMESTAMP}`;
}

function getSmallplugSubdomain(gatewayName: string): string {
  // @ts-expect-error __INTERNAL_SMALLPLUG_SUBDOMAIN is set by host apps on non-prod
  return window.scDK?.__INTERNAL_SMALLPLUG_SUBDOMAIN || gatewayName;
}

function getCommonGatewayDmHost(): string {
  return (
    // @ts-expect-error __INTERNAL_COMMON_GATEWAY_DM_HOST is set by host apps on non-prod
    window.scDK?.__INTERNAL_COMMON_GATEWAY_DM_HOST || COMMON_GATEWAY_DM_HOST
  );
}

export function getSmallPlugHost(
  gatewayName: string,
  useCommonGatewayDm?: boolean,
): string {
  /**
   TESTCODE - used for local development
   return `https://local.smallcase.com`;
   */
  if (useCommonGatewayDm) return getCommonGatewayDmHost();
  const subdomain = getSmallplugSubdomain(gatewayName);
  return `https://${subdomain}.smallcase.com`;
}

export function getSmallPlugIframeURL(
  gatewayName: string,
  path: string,
  params: string,
  themeColor: string,
  useCommonGatewayDm?: boolean,
): string {
  const query = [
    'ct=smallplug_web',
    `color=${encodeURIComponent(themeColor)}`,
    useCommonGatewayDm && `gateway=${encodeURIComponent(gatewayName)}`,
    // params is appended verbatim and last: preserves their encoding and any trailing `#hash`
    params,
  ]
    .filter(Boolean)
    .join('&');
  return `${getSmallPlugHost(gatewayName, useCommonGatewayDm)}/${
    path ?? ''
  }?${query}`;
}

export enum ConnectStatus {
  CONNECTED = 'CONNECTED',
  SAM_CONNECTED = 'SAM_CONNECTED',
  GUEST = 'GUEST',
}

export const LEPRECHAUN_SUFFIX = '-leprechaun';
